module.exports = __webpack_public_path__ + "assets/img/11_756_big.5b05c879.jpg";